<template>
  <div class="title-with-decoration">
    <img class="title-with-decoration__left" :src="leftImage" alt="装饰">
    <span class="title-with-decoration__text">{{ title }}</span>
    <img class="title-with-decoration__right" :src="rightImage" alt="装饰">
  </div>
</template>

<script>
export default {
  name: "TitleWithDecoration",
  props: {
    title: {
      type: String,
      required: true
    },
    leftImage: {
      type: String,
      default: require("@/assets/images/home/title-left.png")
    },
    rightImage: {
      type: String,
      default: require("@/assets/images/home/title-right.png")
    }
  }
};
</script>

<style lang="scss" scoped>
.title-with-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  &__text {
    font-size: 32px;
    font-weight: bold;
    line-height: 32px;
    letter-spacing: normal;
    color: #2B79FE;
  }

  &__left,
  &__right {
    height: 24px;
    width: auto;
  }
}
</style>